import { useAddressBounds } from 'shop/hooks/use-address-bounds';

import { GraphqlError } from 'src/errors';
import { useMarketplaceCategoriesQuery } from 'types/graphql';
import { GenericCategoryRoute } from 'src/generics/data';
import { toGenericCategoryRoute } from 'src/generics/data/generic-marketplace-category';

import { UseCategoriesReturn } from '../categories.types';

const transformData = (data): GenericCategoryRoute[] =>
  data
    ? data.searchProductFilters.map(({ category }) => {
        if (!toGenericCategoryRoute.has(category)) {
          throw new Error(`${category as string} cannot be converted to a GenericCategoryRoute`);
        }

        return toGenericCategoryRoute.get(category);
      })
    : [];

export function useMarketplaceGenericCategoryRoutes(): UseCategoriesReturn {
  const bounds = useAddressBounds();
  const variables = bounds ? { bounds } : undefined;

  const { data, loading, error } = useMarketplaceCategoriesQuery({
    variables,
    skip: !variables,
  });

  if (error) {
    throw new GraphqlError(error);
  }

  return {
    categories: transformData(data),
    loading,
  };
}
